import React from "react";
import { Grid, withStyles } from "@material-ui/core";
import PageTitle from "../../../components/admin/title";
import Widget from "../../../components/admin/widget";
// import {Typography} from "../../../components/admin/wrappers";


const Dashboard = ({ classes, theme, ...props }) => {
	return (
		<>
			<PageTitle title="Dashboard" />
			<Grid container="true" spacing={10}>
				<Grid item lg={3} md={4} sm={6} xs={12}>
					<Widget
						title="Total lots"
						upperTitle
						bodyClass={classes.fullHeightBody}
						className={classes.card}
					>
						<div className={classes.visitsNumberContainer}>
							{/* <Typography size="xl" weight="medium"> */}
								{"278"}
							{/* </Typography> */}
						</div>
					</Widget>
				</Grid>
				<Grid item lg={3} md={8} sm={6} xs={12}>
					<Widget
						title="Available"
						upperTitle
						className={classes.card}
						bodyClass={classes.fullHeightBody}
					>
						<div className={classes.visitsNumberContainer}>
							{/* <Typography size="xl" weight="medium"> */}
								{"278"}
							{/* </Typography> */}
						</div>
					</Widget>
				</Grid>
				<Grid item lg={3} md={8} sm={6} xs={12}>
					<Widget
						title="Not Available"
						upperTitle
						className={classes.card}
						bodyClass={classes.fullHeightBody}
					>
						<div className={classes.visitsNumberContainer}>
							{/* <Typography size="xl" weight="medium"> */}
								{"0"}
							{/* </Typography> */}
						</div>
					</Widget>
				</Grid>
				<Grid item lg={3} md={8} sm={6} xs={12}>
					<Widget
						title="Count"
						upperTitle
						className={classes.card}
						bodyClass={classes.fullHeightBody}
					>
						<div className={classes.visitsNumberContainer}>
							{/* <Typography size="xl" weight="medium"> */}
								{"100"}
							{/* </Typography> */}
						</div>
					</Widget>
				</Grid>
				{/* <Grid item xs={12}>
			  <Widget
				title="Support Requests"
				upperTitle
				noBodyPadding
				bodyClass={classes.tableWidget}
			  >
				<Table data={mock.table} />
			  </Widget>
			</Grid> */}
			</Grid>
		</>
	);
};

const styles = theme => ({
	card: {
		minHeight: "100%",
		display: "flex",
		flexDirection: "column"
	},
	visitsNumberContainer: {
		display: "flex",
		alignItems: "center",
		flexGrow: 1,
		paddingBottom: theme.spacing.unit
	},
	progressSection: {
		marginBottom: theme.spacing.unit
	},
	progressTitle: {
		marginBottom: theme.spacing.unit * 2
	},
	progress: {
		marginBottom: theme.spacing.unit,
		backgroundColor: theme.palette.primary.main
	},
	pieChartLegendWrapper: {
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "flex-end",
		marginRight: theme.spacing.unit
	},
	legendItemContainer: {
		display: "flex",
		alignItems: "center",
		marginBottom: theme.spacing.unit
	},
	fullHeightBody: {
		display: "flex",
		flexGrow: 1,
		flexDirection: "column",
		justifyContent: "space-between"
	},
	tableWidget: {
		overflowX: "auto"
	},
	progressBar: {
		// backgroundColor: theme.palette.warning.main
	},
	performanceLegendWrapper: {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		marginBottom: theme.spacing.unit
	},
	legendElement: {
		display: "flex",
		alignItems: "center",
		marginRight: theme.spacing.unit * 2
	},
	legendElementText: {
		marginLeft: theme.spacing.unit
	},
	serverOverviewElement: {
		display: "flex",
		alignItems: "center",
		maxWidth: "100%"
	},
	serverOverviewElementText: {
		minWidth: 145,
		paddingRight: theme.spacing.unit * 2
	},
	serverOverviewElementChartWrapper: {
		width: "100%"
	},
	mainChartBody: {
		overflowX: "auto"
	},
	mainChartHeader: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		[theme.breakpoints.only("xs")]: {
			flexWrap: "wrap"
		}
	},
	mainChartHeaderLabels: {
		display: "flex",
		alignItems: "center",
		[theme.breakpoints.only("xs")]: {
			order: 3,
			width: "100%",
			justifyContent: "center",
			marginTop: theme.spacing.unit * 3,
			marginBottom: theme.spacing.unit * 2
		}
	},
	mainChartHeaderLabel: {
		display: "flex",
		alignItems: "center",
		marginLeft: theme.spacing.unit * 3
	},
	mainChartSelectRoot: {
		borderColor: `${theme.palette.text.hint}80 !important`
	},
	mainChartSelect: {
		padding: 10,
		paddingRight: 25
	},
	mainChartLegentElement: {
		fontSize: "18px !important",
		marginLeft: theme.spacing.unit
	}
});

export default withStyles(styles)(Dashboard);
